export class SlideRequest {
    slider?: string = null;
    regions?: string[] = null;
}
